<template>
  <div class="bg-f5">
    <div class="patient-inform-wrap">
      <ul>
        <li class="form-table">
          <p class="table-left txt-tit">姓名</p>
          <p class="table-right">{{user.name}}</p>
        </li>
        <li class="form-table">
          <p class="table-left txt-tit">性别</p>
          <p class="table-right">{{user.sex == "2"?'女':user.sex == "1"?'男':''}}</p>
        </li>
        <li class="form-table">
          <p class="table-left txt-tit">年龄</p>
          <p class="table-right">{{user.age}}</p>
        </li>
        <li class="form-table">
          <p class="table-left txt-tit">身份证号</p>
          <p class="table-right">{{user.certNo}}</p>
        </li>
        <li class="form-table">
          <p class="table-left txt-tit">手机号</p>
          <p class="table-right">{{user.phone}}</p>
        </li>
      </ul>
      <ul class="sign-out-btn">
        <li class="out" @click="showModel">退出账号</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import md5 from '@/utils/md5';
  import {mapGetters} from "vuex";

  export default {
    name: "patientInform",
    data() {
      return {
        user:{},
      }
    },
    computed: {
      ...mapGetters([
        "userInfo"
      ]),
    },
    mounted() {
      // this.user = this.$store.getters.userInfo.user || {};
      // this.user = this.userInfo.currentCard || {};
      this.user = this.$store.state.user.userInfo.user || {};
    },
    methods: {
      //弹窗
      showModel: function(item) {
        this.$messagebox.confirm("", {
          message: "确定要退出账号吗？",
          title: "退出账号",
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        }).then(action => {
          this.signOut();
        }).catch(err => {});
      },
      //用户登出接口
      signOut: function() {
        this.$http.logout().then(res => {
          Cookies.remove('userToken'+this.$store.getters.platId);
          Cookies.remove('userId');
          Cookies.remove('userInfo');
          Cookies.remove('uid');
          Cookies.remove('sdktoken');
          Cookies.remove('sessionId');
          Cookies.remove('imDoctorId');
          window.localStorage.removeItem("fromIm");
          sessionStorage.removeItem('userEnter');
          window.localStorage.removeItem('keepLogin');
          this.$router.replace({ path: "/userReg", query: {platId: this.$store.getters.platId}});
          //判断是否对接用户体系跳转
          // let _pageMap = window.ServerConfig.pageMap;
          // let _platId = this.$store.getters.platId;
          // if (_pageMap[_platId]) {
          //   window.location.href = _pageMap[_platId];
          // }else{
          //   this.$router.replace({ path: "/userReg" });
          // }
        }).catch(err => {
          console.log(err);
        });
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patientEnd/patientInform.vue